export class TypeHelper {
    // Returns if a value is a string
    public static isString(value: any) {
        return typeof value === "string" || value instanceof String;
    }

    public static isNumber(value: any) {
        return typeof value === "number" && isFinite(value);
    }

    public static isDate(value: any) {
        return value instanceof Date;
    }

    public static isBoolean(value: any) {
        return typeof value === "boolean";
    }

    public static isNull(value: any) {
        return value === null;
    }

    // Returns if a value is undefined
    public static isUndefined(value: any) {
        return typeof value === "undefined";
    }

    public static isObject(value: any) {
        return value && typeof value === "object" && value.constructor === Object;
    }

    public static isArray(value: any) {
        return Array.isArray(value);
    }

    public static isEmptyArray(array: any[]): boolean {
        return array.length === 0;
    }

    public static toNumber(val: any) {
        if (TypeHelper.isNumber(val)) {
            return val;
        }
        const intVal = parseInt(val.toString());

        return intVal;
    }

    public static toInteger(val: string) {
        if (TypeHelper.stringIsInteger(val)) {
            return parseInt(val.toString());
        }

        return NaN;
    }

    public static isNullOrUndefined(value: any) {
        return value === null || TypeHelper.isUndefined(value);
    }

    public static stringIsInteger(val: string) {
        const regex = /^\d+$/;
        const regexp = new RegExp(regex);
        return regexp.test(val);
    }

    public static isValidIntegerInRange = (value: any, lowerLimit = 0, upperLimit = 59) => {
        const intValue = TypeHelper.toInteger(value);
        if (!isNaN(value) && intValue >= lowerLimit && intValue <= upperLimit) {
            return true;
        }
    };

    /**
     * Do not replace usage with lodash camelCase function. It would break mapping with form values
     * @param str
     * @returns
     */
    public static toCamelCase(str: string) {
        return str
            .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
                return index === 0 ? word.toLowerCase() : word.toUpperCase();
            })
            .replace(/\s+/g, "");
    }

    public static findWordCount = (str: string): number => {
        if (str === null || str === undefined || str === "") {
            return 0;
        }
        str = str.replace(/(^\s*)|(\s*$)/gi, "");
        str = str.replace(/[ ]{2,}/gi, " ");
        str = str.replace(/\n /, "\n");
        return str.split(" ").length;
    };

    public static subtractDecimals(num1: number, num2: number, precision: number = 100): number {
        const factor = Math.pow(10, precision);
        const scaledNum1 = Math.round(num1 * factor);
        const scaledNum2 = Math.round(num2 * factor);
    
        return (scaledNum1 - scaledNum2) / factor;
    }
}
